import axios from 'axios';
import notificationTypesService from '@/services/notification-types.service';

const initialState = () => ({
  notificationTypes: [],
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getNotificationTypes({ commit }) {
    commit('GET_NOTIFICATION_TYPES');
    return notificationTypesService.getNotificationTypes().then(
      (userNotificationSettings) => commit('GET_NOTIFICATION_TYPES_SUCCESS', userNotificationSettings),
      (error) => {
        if (!axios.isCancel(error)) {
          commit('GET_NOTIFICATION_TYPES_ERROR', error);
        }
      },
    );
  },
  RESET(state) {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

const mutations = {
  GET_NOTIFICATION_TYPES(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
    state.notificationTypes = [];
  },
  GET_NOTIFICATION_TYPES_SUCCESS(state, notificationTypes) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.notificationTypes = notificationTypes;
  },
  GET_NOTIFICATION_TYPES_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
};

const getters = {
  notificationTypes: (state) => state.notificationTypes,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const notificationTypes = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
